import { action } from "typesafe-actions";
import { IBooking } from "./booking.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import { showMessage } from "../messages/messagesActions";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";

export const FETCH_BOOKING_LIST_PROGRESS = "FETCH_BOOKING_LIST_PROGRESS";
export const FETCH_BOOKING_LIST_SUCCESS = "FETCH_BOOKING_LIST_SUCCESS";
export const FETCH_BOOKING_LIST_FAILED = "FETCH_BOOKING_LIST_FAILED";

export const fetchBookingListProgress = () =>
	action(FETCH_BOOKING_LIST_PROGRESS);
export const fetchBookingListSuccess = (
	data: IBooking[],
	totalRecords: number
) =>
	action(FETCH_BOOKING_LIST_SUCCESS, {
		data,
		totalRecords,
	});
export const fetchBookingListFailed = () => action(FETCH_BOOKING_LIST_FAILED);

export const fetchBookingByCustomerAsync =
	(
		customer_fact_uuid: string,
		pageNumber: number,
		rowsInPerPage: number,
		date: IDataTableV2DateState["dates"],
		company_outlet_uuid?: string
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchBookingListProgress());

				let url = `/occupancy/get-booking?customer_fact_uuid=${customer_fact_uuid}&pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
				if (company_outlet_uuid) {
					url += `&company_outlet_uuid=${company_outlet_uuid}`;
				}
				const res = await api.get(url);
				const data: IBooking[] = res.data.data;
				const totalRecords = res.data.totalRecords;
				dispatch(fetchBookingListSuccess(data, totalRecords));
			} catch (err: any) {
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};

export const fetchBookingListAsync =
	(
		pageNumber: number,
		rowsInPerPage: number,
		limit: number,
		date: IDataTableV2DateState["dates"],
		companyOutletUuid: string,
		venue_uuid?: string
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
		async (dispatch, getState) => {
			try {
				dispatch(fetchBookingListProgress());
				let url = `/occupancy/get-booking?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;

				if (venue_uuid) {
					url += `&venue_uuid=${venue_uuid}`;
				}
				if (companyOutletUuid) {
					url += `&company_outlet_uuid=${companyOutletUuid}`;
				}
				const res = await api.get(url);
				const data: IBooking[] = res.data.data;
				const totalRecords = res.data.totalRecords;
				dispatch(fetchBookingListSuccess(data, totalRecords));
			} catch (err: any) {
				dispatch(
					showMessage({
						type: "error",
						message: err.response.data.message,
						displayAs: "snackbar",
					})
				);
			}
		};

export const CLEAR_BOOKING_STATE = "CLEAR_BOOKING_STATE";

export const clearBookingState = () => action(CLEAR_BOOKING_STATE);
